module.exports = __webpack_public_path__ + "img/图片14.af67e891.png";